
let OccupationPickerActions = Reflux.createActions([
    'fetchOccupation', 'changeBrowseMode'
]);

class OccupationPickerStore extends Reflux.Store {
    constructor() {
        super();
        this.state = {
            occupation: null,
            browse: true
        };
        this.listenables = OccupationPickerActions;
    }

    onFetchOccupation(onetid, browseMode) {
        let _self = this;
        //note onetid is the internal pk for the model
        var url = buildRoute(mantlroutes.occupation_onet_retrieve,{ "onetid": onetid });
        //get skill list for onet id
        httpGet(url).then(
            function(value){
                // console.log('fetched occupation', JSON.parse(value));
                var response = JSON.parse(value);
                _self.setState({ occupation: response });
                OccupationPickerActions.changeBrowseMode(browseMode)
            })
        .catch(
            function(reason) {
                console.error(JSON.parse(reason));
                alertify.error('Unable to Load Occupation.');
            });
    }

    onChangeBrowseMode(mode){
        if(mode == null){
            mode = true;
        }
        this.setState({ browse: mode })
    }

}

//Reflux.Component extends React.Component
class OccupationGoal extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = new OccupationPickerStore(); // <- just assign the store class itself
    }

    render() {
        let occupationPickerMode = this.state.browse;
        let skillPickerMode = !this.state.browse && this.state.occupation != null;
        return (
            <section>
                {occupationPickerMode && (
                    <OccupationPicker />
                )}

                {skillPickerMode && (
                    <OccupationSkillsPicker occupation={this.state.occupation} post={this.props.post} redirect={this.props.redirect} />
                )}
            </section>
        );
    }
}

//Occupation Search and Selection (onet)
class OccupationPicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.pageNext = this.pageNext.bind(this);
        this.pagePrev = this.pagePrev.bind(this);
        this.pageTo = this.pageTo.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchButton = this.handleSearchButton.bind(this);
        this.refOccupationID = React.createRef();
        this.handleChoose = this.handleChoose.bind(this);
        this.state = {
            page: 1,
            page_size: 10,
            count: 0,
            results: [],
            term: "",
            loading: false,
            searched: false,
            choice: null
        };
    }

    static propTypes = {
        selection_field_id: PropTypes.string
    }

    static defaultProps = {
        selection_field_id: "occupation_id"
    }

    componentDidMount() {

    }

    handleSearch() {
        let _self = this;

        httpGet(buildRoute(mantlroutes.occupation_onet_list) + formatParams({
            pattern: this.state.term,
            page_size: this.state.page_size,
            page: this.state.page
        })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    results: response.results,
                    loading: false,
                    searched: true,
                    count: response.count
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load occupations.', reason);
                alertify.error("Error trying to load occupations.")
            });
    }

    pageNext(event) {
        let newPage = this.state.page + 1;
        let maxPage = Math.ceil(this.state.count/this.state.page_size);
        if(newPage > maxPage) {
            newPage = maxPage; //just in case button is visible when shouldn't be
        }

        this.setState({
                page: newPage,
                loading: true
            },
            function() {
                this.handleSearch();
            }
        );
    }

    pagePrev(event) {
        let newPage = this.state.page - 1;
        if(newPage < 1) {
            newPage = 1; //just in case button is visible on first page
        }
        this.setState({
                page: newPage,
                loading: true
            },
            function() {
                this.handleSearch();
            }
        );
    }

    pageTo(pageNo) {
        let newPage = pageNo;
        this.setState({
                page: newPage,
                loading: true
            },
            function() {
                this.handleSearch();
            }
        );
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSearchButton(event);
        }
    }

    handleSearchButton(event) {
        if(this.state.term.length == 0){
            alertify.log('You Must Enter a Search Term');
        } else {
            this.setState({ page: 1, loading: true }); //a new search needs to reset page
            this.handleSearch();
        }
    }

    handleChoose(occupationID) {
        this.setState({ choice: occupationID });
        this.refOccupationID.current.value = occupationID;
        OccupationPickerActions.fetchOccupation(occupationID, false);
        //Callback
        if(this.props.selection_callback) {
            this.props.selection_callback(occupationID);
        }
    }

    render() {
        const hasResults = this.state.results.length > 0;
        const hasTerm = this.state.term.length > 0;
        const wasSearched = this.state.searched;
        return (
            <div>
                <input type="hidden" id={this.props.selection_field_id} name={this.props.selection_field_id} ref={this.refOccupationID} />
                <label htmlFor="occupation_pattern">Look Up Jobs</label>
                <div className="row text--loosebottom">
                    <div className="column-6 column-plus3">
                        <div className="input-group input-group--full">
                            <input type="search" placeholder="Search Term" title="Search" id="occupation_pattern" name="term" className="input--inline" defaultValue="" onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} />
                            <Button classes="input-suffix button--flat button--neutral button--skinny" onClick={this.handleSearchButton} title="Search for Occupations"><Icon classes="icon-search" title="Search Icon Graphic" /> Find Occupations</Button>
                        </div>
                    </div>
                </div>
                <div role="status" aria-live="assertive">
                {!hasResults && wasSearched && !this.state.loading && (
                    <p className="text--center text--muted text--lg text--loosetop">No Results Found</p>
                )}
                {!hasResults && !wasSearched && !this.state.loading && (
                    <p className="text--center text--muted text--lg text--loosetop">Please Enter a Search Term</p>
                )}
                {hasResults && (
                    <p className="text--center text--muted text--lg text--loosetop">{this.state.results.length} Result(s) Found</p>
                )}
                </div>

                {this.state.loading && (<LoadingSpinner />)}
                <div aria-live="polite">
                    <OccupationPickerItems items={this.state.results} onChoose={this.handleChoose} loading={this.state.loading} choice={this.state.choice} />
                </div>
                {hasResults && (
                    <OccupationPickerPagination page={this.state.page} page_size={this.state.page_size} count={this.state.count} pageNext={this.pageNext} pagePrev={this.pagePrev} pageTo={this.pageTo} />
                )}
            </div>
        );
    }
}


class OccupationPickerPagination extends React.Component {
    //TODO: one day create a new generic pagination component system
    //this is a quick fix
    //adapt old createClass version from Table
    constructor(props) {
        super(props);
    }

    render() {
        const hasNext = this.props.count > this.props.page_size * this.props.page;
        const hasPrev = this.props.page > 1 && (this.props.count > this.props.page_size);
        let skip = 0;
        let maxVisible = 5; //max page numbers listed between prev/next, e.g. Prev 4 5 6 7 8 Next
        let maxPage = Math.ceil(this.props.count/this.props.page_size); //last page possible

        if (this.props.page > maxVisible - 1 && this.props.page < maxPage) {
            skip = this.props.page - maxVisible + 1;
        } else if (this.props.page === maxPage && maxPage >= maxVisible) {
            skip = this.props.page - maxVisible;
        }

        let pageIterator = Array.apply(null, Array( ((maxPage < maxVisible) ? maxPage : maxVisible) )).map(function(v, i) {
            return skip + i + 1;
        });

        let pagingNumbers = pageIterator.map( (page) => <Button selected={(this.props.page === page ? true : false)} classes={"button--flat button--skinny button--sm " + (this.props.page === page ? 'is-active' : '')} title={`Load page ${page}`} key={"pageNo_" + page} onClick={() => this.props.pageTo(page)}>{page}</Button> );

        return (
            <div className="button-group text--loosetop" role="navigation" aria-label="Pagination Navigation">
                <Button classes="button--flat button--skinny button--sm" title="Load Previous Page" onClick={this.props.pagePrev} disabled={!hasPrev}><Icon classes="icon-chevron-left" /> Previous</Button>
                {pagingNumbers}
                <Button classes="button--flat button--skinny button--sm" title="Load Next Page" onClick={this.props.pageNext}>Next <Icon classes="icon-chevron-right" disabled={!hasNext} /></Button>
            </div>
        );

    }
}

class OccupationPickerItems extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const occupations = this.props.items.map((occupation,index) => <OccupationPickerOccupation onChoose={this.props.onChoose} occupation={occupation} extension="png" key={occupation.id} choice={this.props.choice} /> );
        return (
            <ul className="text--loosetop collection">
                {!this.props.loading && (occupations)}
            </ul>
        );

    }
}

class OccupationPickerOccupation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //CollapsibleList
        let titlesList = null;
        let allAltTitles = this.props.occupation.alt_titles;

        return (
            <li className={"collection-item row text--left " + ((this.props.choice == this.props.occupation.id) ? "is-active" : "" )} data-id={this.props.occupation.id} data-onet={this.props.occupation.onet_code} data-year={this.props.occupation.year}>
                <div className="column-5">
                <Icon classes="icon-id-card-o icon--muted" /> <b>{this.props.occupation.title}</b>
                </div>
                <div className="column-5">
                {allAltTitles.length > 0 && (<CollapsibleList list={allAltTitles} header="Alternate/Related Titles" descHeader={`Alternate job titles for ${this.props.occupation.title}`} />)}
                </div>
                <div className="column-2 text--right">
                    <Button classes="button--sm button--skinny" title={`Select ${this.props.occupation.title} and proceed`} onClick={() => this.props.onChoose(this.props.occupation.id)}>Select</Button>
                </div>
            </li>
        );

    }
}
